/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:43:43
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginCollapse from 'bee-collapse';

require('bee-collapse/build/Collapse.css');

export default class Collapse extends Component {
	render() {
		return <OriginCollapse {...this.props} />;
	}
}
